import axiosInstance from "./axiosInstance";
import Configs from "../utils/Configs";

const SinglesUsersApi = {
  fetchSingles: async () => {
    try {
      const params = {};

      const response = await axiosInstance.get(Configs.singlesUsersEp, {
        params,
      });

      if (response.status === 200) {
        return response.data || [];
      } else {
        console.error("Failed to load profiles");
        return [];
      }
    } catch (error) {
      console.error("Error fetching profiles:", error);
      return [];
    }
  },
};

export default SinglesUsersApi;
